import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wjs" }
const _hoisted_2 = { class: "wjs__head" }
const _hoisted_3 = { class: "wjs__count" }
const _hoisted_4 = {
  key: 0,
  class: "wjs__empty text-muted small"
}
const _hoisted_5 = {
  key: 1,
  class: "wjs__list"
}
const _hoisted_6 = {
  key: 0,
  class: "wjs__line"
}
const _hoisted_7 = { class: "wjs__content" }
const _hoisted_8 = { class: "wjs__loc-row" }
const _hoisted_9 = { class: "wjs__loc-name" }
const _hoisted_10 = {
  key: 0,
  class: "wjs__now"
}
const _hoisted_11 = { class: "wjs__times text-muted small font-monospace" }
const _hoisted_12 = { class: "wjs__dwell text-muted small" }
const _hoisted_13 = {
  key: 0,
  class: "wjs__transit text-muted small"
}
const _hoisted_14 = { class: "wjs__transit-label" }
const _hoisted_15 = { class: "font-monospace" }
const _hoisted_16 = { class: "font-monospace" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-signpost-2" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journey')) + " ", 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.legs.length), 1)
    ]),
    (!_ctx.legs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyEmpty')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legs, (leg, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: leg.gwId + leg.since,
              class: "wjs__leg"
            }, [
              (i < _ctx.legs.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["wjs__pin", _ctx.isCurrent(leg) ? 'wjs__pin--current' : '']),
                style: _normalizeStyle({ background: _ctx.isCurrent(leg) ? _ctx.currentColor : _ctx.typeColor(leg.locationType) })
              }, null, 6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(leg.locationName || leg.gwId), 1),
                  (_ctx.isCurrent(leg))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyNow')), 1))
                    : _createCommentVNode("", true),
                  (leg.locationType)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["wjs__type-badge", `wjs__type-badge--${leg.locationType}`])
                      }, _toDisplayString(_ctx.typeLabel(leg.locationType)), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeySince')) + ": " + _toDisplayString(_ctx.fmtTs(leg.since)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyUntil')) + ": " + _toDisplayString(_ctx.fmtTs(leg.until ?? leg.lastSeen)), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyDwell')) + ": " + _toDisplayString(_ctx.durText(leg.since, leg.until ?? Math.floor(Date.now() / 1000))) + " ", 1),
                  (!leg.until)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyOngoing')) + ")", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.transitFor(i))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-truck" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyTransit')) + ": " + _toDisplayString(_ctx.durText(_ctx.transitFor(i).from, _ctx.transitFor(i).to)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyTransitStart')) + ": " + _toDisplayString(_ctx.fmtTs(_ctx.transitFor(i).from)), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('components.wirepasAssets.detail.journeyTransitEnd')) + ": " + _toDisplayString(_ctx.fmtTs(_ctx.transitFor(i).to)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
  ]))
}